import { combineReducers } from '@ngrx/store';

import {
  sortingHasBeenChangedReducer as sortingHasBeenChanged
} from '@app/store/reducers/globalUi/results/filters/sorting-has-been-changed.reducer';
import {
  appliedDateFilterTypeReducer as appliedDateFilterType
} from '@app/store/reducers/globalUi/results/filters/applied-date-filter-widget.reducer';

export const globalUiFiltersByResultsReducer = combineReducers({
  sortingHasBeenChanged,
  appliedDateFilterType,
});
